<template>
  <div data-test-component="questionTree">
    <div v-if="data && !redirecting" class="container main-links">
      <category
        v-for="(value, key, index) in $route.params"
        :id="$route.params['level' + (index + 1)]"
        :key="key"
        :data-test="'question-tree-container-' + index"
        :model="getDataFromId($route.params['level' + (index + 1)], index)"
        :link="routerLink($route.params, index)"
        :category-index="index"
        :selected-policy="selectedPolicy"
      />
      <div v-if="showButton" class="row column">
        <div class="small-12 medium-6 medium-offset-6 large-3 large-offset-9">
          <a
            id="claims-button"
            class="button expanded large"
            data-test="go-to-claim-flow-button"
            @click="goToCreateClaim($event)"
          >Gå til anmeldelse</a>
        </div>
      </div>
    </div>

    <transition name="modal">
      <v-modal
        v-cloak
        :is-open="chooseProduct"
        data-test-claim-question-tree-product-selection-modal
        @close="chooseProduct = false; selectedPolicyId = null;"
      >
        <template #title>
          <h3>Vælg den forsikring, du vil anmelde skaden på</h3>
        </template>
        <template #content>
          <!-- TODO: fix product problem -->
          <div
            v-for="(productListProduct, index) in policiesOfSelectedType"
            :key="'product-' + index"
            class="row"
          >
            <div class="medium-8 columns">
              {{ productListProduct.productDescription }}<br />
              ({{ productListProduct.policyId }})
            </div>
            <div class="medium-4 columns">
              <a
                class="button"
                data-test="question-tree-select-product"
                @click="setSelectedPolicyId(productListProduct.policyId)"
              >Vælg</a>
            </div>
          </div>
        </template>
        <template #footer />
      </v-modal>
    </transition>

    <transition name="modal">
      <v-modal v-cloak :is-open="showDynamicModal" @close="hideDynamicModal">
        <template #title>
          <h3>
            {{ modalObj.title }}
          </h3>
        </template>
        <template #content>
          <div v-html="modalObj.paragraph" />
            <div class="columns grid-x grid-padding-x align-right push-up" v-if="modalObj.ButtonText">
              <button 
                data-test="question-tree-modal-button"
                class="button text-center large-6 medium-6 small-10" 
                @click="redirect(modalObj)" 
                v-html="modalObj.ButtonText"
              />
            </div>
        </template>
        <template #footer />
      </v-modal>
    </transition>
  </div>
</template>

<script>
import { hasProperty } from '@/common/Util/utility.js';
import MediaQueriesMixin from '@/components/Mixins/MediaQueriesMixin';
import Category from '@/components/Feature/ClaimQuestionTree/Category.vue';
import BaseMixin from '@/components/Feature/BaseMixin.vue';
import Utility from '@/common/UtilityFunctions.js';
import ValidatePropsMixin from '@/components/Feature/ValidatePropsMixin.vue';

import { isUndefined } from 'lodash';

export default {
  name: 'Container',
  components: {
    Category
  },
  mixins: [BaseMixin, ValidatePropsMixin, MediaQueriesMixin],
  data() {
    return {
      hasChildren: true,
      damageCode: '',
      chooseProduct: false,
      showDynamicModal: false,
      routerIndex: '',
      modalObj: {},
      topLevelRoute: '/produkter',
      showButton: false,
      redirecting: false,
      selectedPolicyId: null,
      referenceToQuestionnaireId: null,
      actionType: null,
      damageCodeUrlText: '?dc=',
      policyIdUrlText: '&id=',
      actionTypeUrlText: '&actionType=',
    };
  },
  computed: {
    data() {
      return this.$store.getters['claimQuestionTree/data'];
    },
    myProducts() {
      return this.$store.state.claimQuestionTree.myProducts;
    },
    settings() {
      return this.$store.state.claimQuestionTree.settings;
    },
    policyId() {
      const id = Utility.getQueryVariable('id');

      if (id) {
        return decodeURIComponent(id);
      }

      return null;
    },
    rootItem() {
      return this.data.id;
    },
    product() {
      if (isUndefined(this.data)) {
        return {};
      }

      const products = this.data.children;
      let product = null;

      for (var i in products) {
        if (products[i].id === this.$route.params.level2) {
          product = products[i];
        }
      }

      return product;
    },
    levelNumber() {
      return this.$route.fullPath.split('/').length - 1;
    },
    policyTypeSelected() {
      return this.levelNumber !== 1;
    },
    policiesOfSelectedType() {
      if (!this.policyTypeSelected) {
        return null;
      }

      const policyTypeId = this.product.policyTypeId;
      const policies = [];

      for (var i in this.myProducts) {
        if (this.myProducts[i].policyTypeId === policyTypeId) {
          policies.push(this.myProducts[i]);
        }
      }

      return policies;
    },
    hasMultiplePoliciesOfSelectedType() {
      return this.policiesOfSelectedType !== null && this.policiesOfSelectedType.length > 1;
    },
    policyIdInQueryString() {
      return this.policyId !== null;
    },
    claimFlowLink() {
      if (!this.showButton) {
        return '';
      }

      let referenceToQuestionnaireId = '';

      if (this.referenceToQuestionnaireId !== null) {
        referenceToQuestionnaireId = '&ref=' + this.referenceToQuestionnaireId;
      }

      let actionType = '';

      if (this.actionType !== null) {
        actionType = this.actionTypeUrlText + this.actionType;
      }

      return (
        this.settings.flowUrl +
        this.damageCodeUrlText +
        this.damageCode +
        this.policyIdUrlText +
        this.selectedPolicyId +
        referenceToQuestionnaireId +
        actionType
      );
    },
    getMyProductFromPolicyId() {
      let myProduct = null;

      for (let i in this.myProducts) {
        if (this.myProducts[i].policyId === this.policyId) {
          myProduct = this.myProducts[i];
          break;
        }
      }

      return myProduct;
    },
    getPolicyObjectFromQueryStringId() {
      let policyObject = null;

      for (let i in this.data.children) {
        if (
          this.getMyProductFromPolicyId !== null &&
          this.data.children[i].policyTypeId === this.getMyProductFromPolicyId.policyTypeId
        ) {
          policyObject = this.data.children[i];
          break;
        }
      }

      return policyObject;
    },
    hasSubItems() {
      return (
        this.getPolicyObjectFromQueryStringId !== null &&
        this.getPolicyObjectFromQueryStringId.section !== null
      );
    },
    queryStringPolicyTypeMatchesRouterPolicyType() {
      let queryStringPolicyIdPolicyTypeId = null;
      let routerPathProductPolicTypeId = null;

      if (this.getMyProductFromPolicyId !== null && this.policiesOfSelectedType !== null) {
        queryStringPolicyIdPolicyTypeId = this.getMyProductFromPolicyId.policyTypeId;
        routerPathProductPolicTypeId = this.policiesOfSelectedType[0].policyTypeId;
      }

      return queryStringPolicyIdPolicyTypeId === routerPathProductPolicTypeId;
    },
    selectedPolicy() {
      const selectedPolicy = {
        isActive: null,
        isCarLeased: null,
      };

      if (this.selectedPolicyId === null) {
        return selectedPolicy;
      }

      for (let i in this.myProducts) {
        if (this.myProducts[i].policyId === this.selectedPolicyId) {
          selectedPolicy.isActive = this.myProducts[i].isActive;
          selectedPolicy.isCarLeased = this.myProducts[i].isCarLeased;
          break;
        }
      }

      return selectedPolicy;
    },
  },
  watch: {
    $route() {      
      if (
        this.levelNumber === 2 &&
        this.hasMultiplePoliciesOfSelectedType &&
        !this.policyIdInQueryString
      ) {
        // this.chooseProduct = true;        
      }

      if (this.levelNumber === 2 && !this.hasMultiplePoliciesOfSelectedType) {
        this.selectedPolicyId = this.policiesOfSelectedType[0].policyId;
      }

      if (
        this.levelNumber === 2 &&
        this.policyIdInQueryString &&
        this.hasMultiplePoliciesOfSelectedType &&
        !this.queryStringPolicyTypeMatchesRouterPolicyType
      ) {
        return;
      }

      this.$nextTick(() => {
        if (!this.chooseProduct && !this.showDynamicModal) {
          this.scrollToId();
        }
        this.showButton = false;
      });

      this.referenceToQuestionnaireId = null;
      this.actionType = null;
    },
    data() {
      if (this.policyId) {
        if (!this.hasSubItems) {
          this.redirecting = true;
          return Utility.redirect(this.settings.flowUrl + this.damageCodeUrlText + this.policyIdUrlText + this.policyId);
        }

        if (
          this.$route.path.split('/').length < 4 &&
          this.getPolicyObjectFromQueryStringId !== null
        ) {
          return this.$router.push(
            this.topLevelRoute + '/' + this.getPolicyObjectFromQueryStringId.id
          );
        }
      }

      if (!this.queryStringPolicyTypeMatchesRouterPolicyType) {
        return;
      }

      return this.$nextTick(() => this.scrollToId());
    },
    hasMultiplePoliciesOfSelectedType(val) {
      this.chooseProduct = val && !this.policyIdInQueryString;

      if (!val && this.policiesOfSelectedType !== null) {
        this.selectedPolicyId = this.policiesOfSelectedType[0].policyId;
      }
    }
  },
  async mounted() {    
    if (this.policyIdInQueryString) {
      this.selectedPolicyId = this.policyId;
    }

    Utility.setCookieThatExpiresInParamMinutes('question-tree-create-claim-tracking-start-time', new Date(), 60);

    await this.$nextTick();

    if (!this.queryStringPolicyTypeMatchesRouterPolicyType) {
      return this.$router.push(this.topLevelRoute + '/' + this.getPolicyObjectFromQueryStringId.id);
    }
  },
  methods: {
    routerLink(params, index) {
      let str = '/';
      let i = 0;

      for (var key in params) {
        if (i <= index) {
          str += params[key] + '/';
        }
        i++;
      }

      return str;
    },
    getDataFromId(level, index) {
      this.routerIndex = index;

      if (level === this.rootItem) {
        return this.data;
      }

      const obj = this.jsonSearch(this.data.children, level);

      if (hasProperty(obj, 'section') && obj.section === null) {
        if (!this.showDynamicModal) {
          this.showButton = true;
        }

        let damageCodes = '';
        let referenceToQuestionnaireId = '';
        let actionType = '';

        $.each(obj.action, (i, v) => {
          if (v.type === 'Modal') {
            this.modalObj = v;
            this.showDynamicModal = true;
          }

          damageCodes += v.id + '/';

          if (v.referenceToQuestionnaireId !== null) {
            referenceToQuestionnaireId += v.referenceToQuestionnaireId + '/';
          }
          if (v.actionType !== null) {
            actionType += v.actionType + '/';
          }
        });

        if (referenceToQuestionnaireId !== '') {
          this.referenceToQuestionnaireId = referenceToQuestionnaireId.slice(0, -1);
        }

        if (actionType !== '') {
          this.actionType = actionType.slice(0, -1);
        }

        this.damageCode = damageCodes.slice(0, -1);
      }

      return obj.section;
    },
    // paramaters: model: tree structure (default: root), id: selected question on level
    jsonSearch(model, id) {
      // iterate question tree model
      for (var i = 0; i < model.length; i++) {
        // if id is not part of url then skip to next
        const urlSegments = location.hash.split('/');
        if (!urlSegments.some((p) => p === model[i].id)) {
          continue;
        }

        // if current model matches the clicked one, return it
        if (model[i].id === id) {
          this.json = model[i];
        } else {
          // else try again with children of current model
          this.jsonSearch(model[i].section.children, id);
        }
      }

      return this.json;
    },
    hideDynamicModal() {
      if (this.levelNumber === 3) {
        this.$router.push(this.topLevelRoute).then(() => {
          this.showDynamicModal = false;
        });

        return Utility.scrollToElem('#produkter', this.getScrollDistance());
      }

      return this.$router
        .push(this.routerLink(this.$route.params, this.routerIndex - 1).slice(0, -1))
        .then(() => {
          this.showDynamicModal = false;
        });
    },
    getScrollDistance() {
      const isScrolled = $(document).scrollTop() > 0;

      let shortDistance = 70;
      let longDistance = 110;

      if (this.mediaQueries.isMediumUp) {
        shortDistance = 90;
        longDistance = 110;
      }

      if (this.mediaQueries.isLargeUp) {
        shortDistance = 170;
        longDistance = 230;
      }

      if (isScrolled) {
        return shortDistance;
      }

      return longDistance;
    },
    scrollToId(deduct = 0) {
      if (window.location.hash === '#/produkter') {
        return;
      }

      const level = this.$route.name.substring(5) - deduct;
      const id = this.$route.params['level' + level];
      const scrollToId = this.showButton ? 'claims-button' : id;

      Utility.scrollToElem('#' + scrollToId, this.getScrollDistance());
    },
    goToCreateClaim(e) {
      e.preventDefault();

      if (this.selectedPolicyId === null) {    
        return this.chooseProduct = true;
      }

      const eventLabel = this.$route.path.replaceAll('/', '|').replaceAll('-', '_').replace('|', '');

      Utility.setCookieThatExpiresInParamMinutes('question-tree-create-claim-tracking-event-label', eventLabel, 60);

      this.$store.dispatch('Events/register', {
        event: 'question-tree-go-to-create-claim-click',
        id: 'reportClaim',
        vm: {
          product: this.product.title.toLowerCase(),
          damageCodesString: eventLabel,
          damageCodeDescription: this.$route.path.substring(this.$route.path.lastIndexOf('/') + 1)
        }
      });

      setTimeout(() => {
        return window.location.href = this.claimFlowLink;
      }, 200);
    },
    setSelectedPolicyId(id) {
      if (this.levelNumber !== 2 && this.selectedPolicyId === null) {
        this.selectedPolicyId = id;
        this.chooseProduct = false;

        return Utility.redirect(this.claimFlowLink);
      }

      this.selectedPolicyId = id;
      this.chooseProduct = false;
      Utility.scrollToElem('#' + this.$route.params.level2, this.getScrollDistance());
    },
    redirect(modalObj) {
      let numberOfContentPolicies = '';
      let contentPolicyId = '';

      // Check myProducts for more than one content policy
      this.myProducts.forEach(policy => {
        if (policy.policyType === 'Content') {
          numberOfContentPolicies += 1;
          contentPolicyId = policy.policyId;
        }
      });

      // If there is more than one, close the modal and scroll to the top of the question tree
      if (numberOfContentPolicies != 1) {
        this.$router
          .push(this.topLevelRoute)
          .then(() => {
            this.showDynamicModal = false;
            this.scrollToTop();
          });
      } else {
        // If there is only one, redirect to the content policy theft flow
        const carTheftRedirectLink =
          modalObj.ContentTheftClaimFlowUrl +
          this.damageCodeUrlText +
          modalObj.DamageCodeContentTheft +
          this.policyIdUrlText +
          contentPolicyId +
          this.actionTypeUrlText;
          
        window.location = carTheftRedirectLink;
      }
    }
  }
};
</script>
